import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { apiFetch } from '../../api/api';
import '../../styles/form-layout.css';
import AddUserModal from './AddUserModal';
import AddDeviceModal from './AddDeviceModal';
import { useOrg } from './org-context'; // adjust path as needed
import { toast } from 'react-toastify';
import { useAuth } from '../../auth/auth-context'; // adjust path if needed
import { getOrgPermissions } from './orgPermissions';
import { SERVER_URL } from '../../constants/server-type';
import { downloadJsonFromApi } from '../../utils/downloadFile';
import MediaPickerModal from '../../pages/media/MediaPickerModal';


export default function OrgUpdatePage() {
  const { orgId: p1, id: p2 } = useParams();
  const navigate = useNavigate();

  const orgId = p1 || p2;
  const isNew = !orgId || orgId === 'new' || orgId === 'add';

  const [org, setOrg] = useState({});
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  // const [showAddUser, setShowAddUser] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  const [userRole, setUserRole] = useState('org:view');
  const { memberships, activeOrgId } = useOrg();
  const [pending, setPending] = useState([]);
  const { user: currentUser } = useAuth();
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [showAddDeviceModal, setShowAddDeviceModal] = useState(false);
  const adminCount = users.filter(
    u => u.role === 'org:admin'
  ).length;
  const { issuperadmin, user } = useAuth();
  const [editingAlias, setEditingAlias] = useState(null);
  const [aliasInput, setAliasInput] = useState('');
  const [devices, setDevices] = useState([]);
  const [deviceLoading, setDeviceLoading] = useState(true);
  const [showHeaderPicker,setShowHeaderPicker] = useState(false);
  const [showLoginPicker,setShowLoginPicker] = useState(false);
  const activeMembership = memberships.find(
    m => String(m.orgId) === String(activeOrgId)
  );
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'org';

  const setActiveTab = (tab) => {
    setSearchParams({ tab });
  };

  console.log("activeMembership:", activeMembership)
  const {
    isOwner,
    isAdmin,
    canAddUser
  } = getOrgPermissions({
    memberships,
    activeOrgId,
    issuperadmin
  });

  console.log("isOwner", isOwner)
  console.log("isAdmin", isAdmin)
  console.log("canAddUser", canAddUser)

  const isOrgAdmin = isOwner || isAdmin;


    async function loadUsers() {
      const u = await apiFetch(`/org/${orgId}/users`);
      setUsers(u || []);

    }


  async function loadPending() {
    const data = await apiFetch(`/org/${orgId}/invites`);
    setPending(
      (data || []).sort(
        (a, b) => new Date(a.inviteExpiresAt) - new Date(b.inviteExpiresAt)
      )
    );
  }



  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        setLoading(true);

        if (!isNew) {
          const o = await apiFetch(`/org/${orgId}`);
          if (!cancelled) setOrg(o || {});

          const u = await apiFetch(`/org/${orgId}/users`);
          if (!cancelled) setUsers(u || []);


        } else {
          setOrg({});
          setUsers([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => { cancelled = true; };
  }, [orgId, isNew, activeOrgId]);

  useEffect(() => {
    loadDevices();
  }, [orgId]);

  async function loadDevices() {
    try {
      setDeviceLoading(true);

      const data = await apiFetch(`/api/printmanager/devices?orgId=${orgId}`);

      console.log("📥 raw devices:", data);

      const normalized = (data || []).map(d => ({
        deviceId: d.deviceId || d._id || d.id,
        deviceName: d.deviceName || d.alias || '',
        ...d
      }));

      console.log("✅ normalized devices:", normalized);

      setDevices(normalized);

    } catch (err) {
      console.error("❌ loadDevices error:", err);
      toast.error("Failed to load devices");
    } finally {
      setDeviceLoading(false);
    }
  }

  useEffect(() => {
  if (activeTab === 'pending' && orgId) {
    loadPending();
  }
}, [activeTab, orgId]);

async function updateUserRole(membershipId, role) {
  await apiFetch(
    `/org/${orgId}/users/${membershipId}/role`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: { role }
    }
  );

  setUsers(u =>
    u.map(m =>
      m._id === membershipId
        ? { ...m, role }
        : m
    )
  );

  toast.success('Role updated');
}

async function saveAlias(deviceId) {
  try {
    await apiFetch(`/api/printmanager/devices/${deviceId}`, {
      method: 'PATCH',
      body: { deviceName: aliasInput }
    });

    await loadDevices(); // 🔥 always refresh from server

    toast.success('Alias updated');
    setEditingAlias(null);
  } catch (err) {
    toast.error(err.message || 'Failed to update alias');
  }
}

function cancelAliasEdit() {
  setEditingAlias(null);
  setAliasInput('');
}

function confirmRemoveDevice(deviceId) {
  toast.info(
    ({ closeToast }) => (
      <div>
        Remove device <b>{deviceId}</b>?
        <div style={{ marginTop: '6px' }}>
          <button
            className="btn small danger"
            onClick={async () => {
              try {
                await apiFetch(`/org/${orgId}/devices/${deviceId}`, {
                  method: 'DELETE'
                });

                // ✅ update ORG (if still used elsewhere)
                setOrg(o => ({
                  ...o,
                  devices: (o.devices || []).filter(d => d.deviceId !== deviceId)
                }));

                // 🔥 CRITICAL FIX: update DEVICES STATE
                setDevices(d =>
                  (d || []).filter(dev => dev.deviceId !== deviceId)
                );

                toast.success('Device removed');
                closeToast();

              } catch (err) {
                toast.error(err.message || 'Failed to remove device');
              }
            }}
          >
            Yes, Remove
          </button>

          <button
            className="btn small"
            onClick={closeToast}
            style={{ marginLeft: '8px' }}
          >
            Cancel
          </button>
        </div>
      </div>
    ),
    { autoClose: false }
  );
}

function confirmRemoveUser(membership) {
  const name =
    `${membership.user?.firstName || ''} ${membership.user?.lastName || ''}`.trim() ||
    membership.user?.email ||
    'this user';

  toast.info(
    <div>
      <div style={{ marginBottom: 8 }}>
        Remove <b>{name}</b> from this account?
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
      <button
        className="btn small danger"
        disabled={membership.role === 'org:owner' && users.filter(u => u.role === 'org:owner').length <= 1}
        title={
          membership.role === 'org:owner' && users.filter(u => u.role === 'org:owner').length <= 1
            ? 'An organization must have at least one owner'
            : undefined
        }
        onClick={async () => {
          toast.dismiss(`remove-user-${membership._id}`);
          try {
            await apiFetch(
              `/org/${orgId}/users/${membership._id}`,
              { method: 'DELETE' }
            );
            setUsers(u => u.filter(m => m._id !== membership._id));
            toast.success('User removed');
          } catch (err) {
            toast.error(err.message || 'Failed to remove user');
          }
        }}
      >
        Remove
      </button>


        <button
          className="btn small secondary"
          onClick={() => toast.dismiss(`remove-user-${membership._id}`)}
        >
          Cancel
        </button>
      </div>
    </div>,
    {
      toastId: `remove-user-${membership._id}`,
      autoClose: false,
      closeOnClick: false
    }
  );
}

async function resendInvite(id) {
  await apiFetch(`/org/${orgId}/invites/${id}/resend`, {
    method: 'POST'
  });
  toast.success('Invitation resent');
}

async function revokeInvite(id) {
  await apiFetch(`/org/${orgId}/invites/${id}`, {
    method: 'DELETE'
  });
  toast.success('Invitation revoked');
  setPending(p => p.filter(x => x._id !== id));
}


  const set = (k, v) => setOrg(o => ({ ...o, [k]: v }));

  async function save() {
    if (isNew) {
      await apiFetch('/org', { method: 'POST', body: org });
    } else {
      await apiFetch(`/org/${orgId}`, { method: 'PUT', body: org });
    }
    navigate('/orgs');
  }

  if (loading || deviceLoading) return <div className="form-page">Loading…</div>;

  console.log("isNew:", isNew)
  console.log("isOrgAdmin:", isOrgAdmin)
  console.log("orgId:", orgId)
  console.log("activeOrgId:", activeOrgId)
  console.log("devices:", devices)

  return (
    <div className="form-page">

      {/* Header */}
      <div className="form-header">
        <div className="form-title">
          {isNew ? 'Add Account' : 'Account Settings'}
        </div>
        <div className="form-header-actions">
          {activeTab === 'org' && (
            <>
              <button
                className="btn secondary"
                onClick={() => navigate('/orgs')}
              >
                Cancel
              </button>
              <button
                className="btn success"
                onClick={save}
              >
                Save
              </button>
            </>
          )}

          {activeTab === 'users' && isOrgAdmin && (
            <button
              className="btn-primary"
              onClick={() => setShowAddUserModal(true)}
            >
              Add User
            </button>
          )}

          {activeTab === 'devices' && isOrgAdmin && (
            <button
              className="btn-primary"
              onClick={() => setShowAddDeviceModal(true)}
            >
              Add Device
            </button>
          )}


        </div>

      </div>

      {/* Tabs */}
      <div className="form-tabs">
        <div
          className={`form-tab ${activeTab === 'org' ? 'active' : ''}`}
          onClick={() => setActiveTab('org')}
        >
          Account
        </div>

        {!isNew && isOrgAdmin && (
          <div
            className={`form-tab ${activeTab === 'users' ? 'active' : ''}`}
            onClick={() => setActiveTab('users')}
          >
            Users
          </div>
        )}
        {!isNew && isOrgAdmin && (
          <div
            className={`form-tab ${activeTab === 'pending' ? 'active' : ''}`}
            onClick={() => setActiveTab('pending')}
          >
            Pending
          </div>
        )}
        {!isNew && isOrgAdmin && (
          <div
            className={`form-tab ${activeTab === 'devices' ? 'active' : ''}`}
            onClick={() => setActiveTab('devices')}
          >
            Devices
          </div>
        )}
      </div>

      {/* Account tab */}
      {activeTab === 'org' && (
        <div className="form-section">
          <div className="form-grid">
            {[
              ['organization', 'Account Name'],
              ['acctNumber', 'Account Number'],
              ['website', 'Website'],
              ['street1', 'Street Address'],
              ['street2', 'Address (cont.)'],
              ['city', 'City'],
              ['state', 'State'],
              ['postal', 'Postal Code'],
              ['country', 'Country'],
            ].map(([k, label]) => (
              <div className="form-field" key={k}>
                <div className="form-label">{label}</div>
                <input
                  className="form-input"
                  value={org[k] || ''}
                  onChange={e => set(k, e.target.value)}
                  disabled={k === 'acctNumber'}
                />
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Users tab */}
      {activeTab === 'users' && (
        <div className="form-section">
          <div className="section-header">
            <div className="section-title" style={{paddingLeft:"10px", fontWeight:"500"}}>Users</div>
          </div>
          {users.length === 0 ? (
            <div className="form-muted">No users in this account</div>
          ) : (
            <div className="user-list">
              {users.map(m => (
                <div key={m._id} className="user-row compact">
                  <div className="user-col name">
                    {m.user?.firstName || ''} {m.user?.lastName || ''}
                  </div>

                  <div className="user-col email">
                    {m.user?.email}
                  </div>

                  <div className="user-col role">
                    {isOrgAdmin ? (
                      <select
                        value={m.role}
                        disabled={m.user?._id === currentUser?._id}
                        title={
                          m.user?._id === currentUser?._id
                            ? 'You cannot change your own role'
                            : undefined
                        }
                        onChange={e =>
                          updateUserRole(m._id, e.target.value)
                        }
                      >
                        <option value="org:view">Viewer</option>
                        <option value="org:admin">Admin</option>
                      </select>
                    ) : (
                      m.role
                    )}
                  </div>



                  <div className="user-col actions">
                    {isOrgAdmin && (
                      <button
                        className="btn small danger"
                        disabled={m.role === 'org:admin' && adminCount <= 1}
                        title={
                          m.role === 'org:admin' && adminCount <= 1
                            ? 'An organization must have at least one admin'
                            : 'Remove user from organization'
                        }
                        onClick={() => confirmRemoveUser(m)}
                      >
                        Remove
                      </button>
                    )}
                  </div>


                </div>
              ))}
            </div>
          )}



        </div>
      )}

      {activeTab === 'pending' && (
        <div className="form-section">

          {pending.length === 0 ? (
            <div className="form-muted">
              No pending invitations
            </div>
          ) : (
            <div className="user-list">
              {pending.map(p => (
                <div key={p._id} className="user-row compact">
                  <div className="user-col email">
                    {p.email}
                  </div>

                  <div className="user-col role">
                    {p.roles?.[0]}
                  </div>

                  <div className="user-col actions">
                    <button
                      className="btn small secondary"
                      onClick={() => resendInvite(p._id)}
                    >
                      Resend
                    </button>

                    <button
                      className="btn small danger"
                      onClick={() => revokeInvite(p._id)}
                    >
                      Revoke
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

        {/* Devices tab */}
        {activeTab === 'devices' && (
          <div className="form-section">
            <div className="section-header">
              <div className="section-title" style={{ paddingLeft: '10px', fontWeight: '500' }}>Devices</div>
            </div>

            {devices.length === 0 ? (
              <div className="form-muted">
                No devices linked yet.<br />
                Click <b>Add Device</b> and enter the code shown on your PrintManager screen.
              </div>
            ) : (
              <div className="user-list">
              {devices
                .filter(d => d.deviceId)
                .map((device) => (
                  <div key={device.deviceId} className="user-row compact">

                    <div className="user-col name">
                      {editingAlias === device.deviceId ? (
                        <input
                          className="form-input small"
                          value={aliasInput}
                          onChange={(e) => setAliasInput(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') saveAlias(device.deviceId);
                            if (e.key === 'Escape') cancelAliasEdit();
                          }}
                          autoFocus
                        />
                      ) : (
                        <div>
                          <strong>{device.deviceName || '(no name)'}</strong>
                          <br />
                          <small style={{ color: '#999' }}>{device.deviceId}</small>
                        </div>
                      )}
                    </div>
                    <small style={{ color: device.lastSeen ? 'green' : '#999' }}>
                      {device.lastSeen ? 'Online' : 'Offline'}
                    </small>
                    <div className="user-col actions">
                      {editingAlias === device.deviceId ? (
                        <>
                          <button className="btn small success" onClick={() => saveAlias(device.deviceId)}>Save</button>
                          <button className="btn small secondary" onClick={cancelAliasEdit}>Cancel</button>
                        </>
                      ) : (
                        <>
                          <button
                            className="btn small"
                            onClick={() => {
                              setEditingAlias(device.deviceId);
                              setAliasInput(device.deviceName || '');
                            }}
                          >
                            Edit
                          </button>

                          <button
                            className="btn small danger"
                            onClick={() => confirmRemoveDevice(device.deviceId)}
                          >
                            Remove
                          </button>
                        </>
                      )}
                    </div>

                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {showAddDeviceModal && (
          <div className="modal-backdrop" onClick={() => setShowAddDeviceModal(false)}>
            <div onClick={(e) => e.stopPropagation()}>
              <AddDeviceModal
                orgId={orgId}
                currentDevices={devices || []}
                onClose={() => setShowAddDeviceModal(false)}
                onAdded={async () => {
                  await loadDevices();
                }}
              />
            </div>
          </div>
        )}

      {/* Actions */}
      {showAddUserModal && (
        <div className="modal-backdrop" onClick={() => setShowAddUserModal(false)}>
          <div onClick={(e) => e.stopPropagation()}>
            <AddUserModal
              orgId={activeOrgId}
              onClose={() => setShowAddUserModal(false)}
              onAdded={() => {
                // refresh users + pending lists
                loadUsers();
                loadPending();
                window.location.reload();
              }}
            />
          </div>
        </div>
      )}

    </div>
  );
}
